/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React from "react";
import { Box, Heading, Flex, Text } from "@theme-ui/components";
import { Icon } from '../atoms';
import { colors, typography } from '../../styles/theme';
import { InfoTile } from '../molecules';

const BottomLabel = ({ topic }) => (
  <Box>
    <Icon name="Tag" color={colors.black} size={16} />
    <Text sx={{ pl: "0.5rem", ...typography.textSm, color: colors.black }}>
      {topic}
    </Text>
  </Box>
);

export const RelatedGuides = ({ posts, regionCode = "IN", regionPath }) => {
  const regionalPosts = posts.filter((p) => p.regionCode.includes(regionCode));
  if (!regionalPosts || regionalPosts.length <= 0) {
    return null;
  }

  return (
    <Box sx={{ my: ["4rem", "4rem", "7rem", "7rem"] }}>
      <Heading as="h2" sx={{ ...typography.h2, textAlign: "center" }}>
        Related Posts
      </Heading>
      <Flex
        sx={{
          justifyContent: "center",
          flexWrap: "wrap",
          width: "100%",
          mt: ["1.5rem", "1.5rem", "1.5rem", "3rem"],
        }}
      >
        {regionalPosts.map((post, index) => (
          <InfoTile
            key={`recent-posts-${index}`}
            image={post.bannerImage.gatsbyImageData}
            imageAltText={post.bannerImage.alt}
            title={post.title}
            content={post.subTitle}
            hasBorder={false}
            url={
              regionPath && regionPath !== ""
                ? `/${regionPath}/${post.slug}/`
                : `/${post.slug}/`
            }
            bottomLabel={
              post.topic && post.topic.name ? (
                <BottomLabel topic={post.topic.name} />
              ) : null
            }
            customStyles={{ width: ["100%", "100%", "22rem", "24.375rem"] }}
          />
        ))}
      </Flex>
    </Box>
  );
};
